import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

interface TabHeaderProps {
  active: boolean;
}

export const TabHeaderStyled = styled.div<TabHeaderProps>`
  box-sizing: border-box;
  text-align: center;
  padding: 7px 0;
  font-display: block;
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.bodySmall)};
  cursor: pointer;

  color: ${(props) =>
    props.active
      ? props.theme.atlas.semantic.color.type.default
      : props.theme.atlas.semantic.color.type.muted};

  ${(props) =>
    props.active
      ? {
          'border-bottom': `1px solid ${props.theme.atlas.semantic.color.action.primary.default};`,
        }
      : ''}

  &:hover {
    color: ${(props) => props.theme.atlas.semantic.color.type.default};
  }
`;
